// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/RoleService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { IdentityRoleCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { IdentityRoleDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { IdentityRoleFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/RoleService.proto.
 */
export const file_Services_RoleService: GenFile = /*@__PURE__*/
  fileDesc("ChpTZXJ2aWNlcy9Sb2xlU2VydmljZS5wcm90bzLuAgoLUm9sZVNlcnZpY2UStgEKB0dldFJvbGUSJi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkRHRvGjgudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5JZGVudGl0eVJvbGVEZXRhaWxlZER0byJJoNrNDwGC0+STAj5aFjoBKiIRL2FwaS9yb2xlL2dldFJvbGUSJC9hcGkvcm9sZS9nZXRSb2xlL3toaWdoXzY0fS97bG93XzY0fRKlAQoIR2V0Um9sZXMSNi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmZpbHRlcnMuSWRlbnRpdHlSb2xlRmlsdGVyc0R0bxo9LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29sbGVjdGlvbnMuSWRlbnRpdHlSb2xlQ29sbGVjdGlvbkR0byIioNrNDwGC0+STAhc6ASoiEi9hcGkvcm9sZS9nZXRSb2xlc0IkqgIhTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLlNlcnZpY2VzYgZwcm90bzM", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * Read operations for Identity roles.
 *
 * @generated from service RoleService
 */
export const RoleService: GenService<{
  /**
   * Fetch a role specified by its id.
   *
   * @generated from rpc RoleService.GetRole
   */
  getRole: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof IdentityRoleDetailedDtoSchema;
  },
  /**
   * Fetch roles according to filters.
   *
   * @generated from rpc RoleService.GetRoles
   */
  getRoles: {
    methodKind: "unary";
    input: typeof IdentityRoleFiltersDtoSchema;
    output: typeof IdentityRoleCollectionDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_RoleService, 0);

